import request from '@/utils/request'

export function add(disease) {
  return request({
    url: '/InfoSyndrome/addData',
    method: 'post',
    data: disease
  })
}

export function edit(disease) {
  return request({
    url: '/InfoSyndrome/editData',
    method: 'post',
    data: disease
  })
}

export function getById(id) {
  return request({
    url: `/InfoSyndrome/getById/${id}`,
    method: 'post'
  })
}
